import { render, staticRenderFns } from "./logo-acquire.vue?vue&type=template&id=4d9a08fe&"
var script = {}
import style0 from "./logo-acquire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports